(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-mb-video]').forEach((container) => {
      if (container.dataset.mbBound) return;
      container.dataset.mbBound = 'true';
      const button = container.querySelector('[data-mb-video-play]');
      const poster = container.querySelector('[data-mb-video-poster]');
      const status = container.querySelector('[data-mb-video-status]');
      const retry = container.querySelector('[data-mb-video-retry]');
      if (!button || !container.dataset.videoSource) return;
      button.hidden = false;
      let playAttempt = 0;
      let loadTimer;
      const clearLoadTimer = () => {
        if (loadTimer !== undefined) clearTimeout(loadTimer);
        loadTimer = undefined;
      };
      const start = () => {
        const attempt = ++playAttempt;
        clearLoadTimer();
        const previous = container.querySelector('video, iframe');
        previous?.pause?.();
        previous?.remove();
        if (retry) retry.hidden = true;
        let failed = false;
        const fail = (media) => {
          if (attempt !== playAttempt || failed) return;
          failed = true;
          clearLoadTimer();
          media.remove();
          poster.hidden = false;
          status.hidden = false;
          status.textContent = container.dataset.videoError || 'The video could not load. Try again or open the full video below.';
          button.disabled = false;
          if (retry) retry.hidden = false;
        };
        status.textContent = container.dataset.videoLoading || 'Loading video…';
        status.hidden = false;
        button.disabled = true;
        if (container.dataset.videoProvider === 'youtube') {
          const id = container.dataset.youtubeId;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) {
            fail({ remove() {} });
            return;
          }
          // No YouTube frame, script or network request exists until a visitor clicks.
          const frame = document.createElement('iframe');
          frame.title = container.dataset.videoDescription;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.setAttribute('tabindex', '0');
          frame.addEventListener('error', () => fail(frame), { once: true });
          frame.addEventListener('load', () => {
            if (attempt !== playAttempt || failed) return;
            clearLoadTimer();
            poster.hidden = true;
            status.hidden = true;
            if (retry) retry.hidden = false;
            frame.focus({ preventScroll: true });
          }, { once: true });
          const language = encodeURIComponent(container.dataset.videoLanguage || 'en');
          frame.src = `https://www.youtube.com/embed/${id}?autoplay=1&controls=1&playsinline=1&disablekb=0&rel=0&hl=${language}`;
          container.insertBefore(frame, status);
          // Some browsers emit neither load nor error when an iframe request is blocked.
          loadTimer = setTimeout(() => fail(frame), 10000);
          if (retry) retry.hidden = false;
          return;
        }
        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.muted = false;
        video.defaultMuted = false;
        video.setAttribute('tabindex', '0');
        video.setAttribute('aria-label', container.dataset.videoDescription);
        video.poster = poster.querySelector('img')?.currentSrc || '';
        // Also handles resume from native controls, without changing sound or timing.
        video.addEventListener('play', () => {
          document.querySelectorAll('[data-mb-video] video').forEach((other) => {
            if (other !== video && !other.paused) other.pause();
          });
        });
        video.addEventListener('error', () => fail(video), { once: true });
        video.addEventListener('loadeddata', () => {
          if (attempt !== playAttempt || failed) return;
          poster.hidden = true;
          status.hidden = true;
          video.focus({ preventScroll: true });
        }, { once: true });
        // Keep media URLs out of src/source until an explicit visitor action.
        video.src = container.dataset.videoSource;
        container.insertBefore(video, status);
        video.play().catch(() => {
          if (attempt !== playAttempt || failed) return;
          if (video.error) fail(video);
          else {
            poster.hidden = true;
            status.hidden = false;
            status.textContent = container.dataset.videoControls || 'Use the video controls to start playback.';
            button.disabled = false;
          }
        });
      };
      button.addEventListener('click', start);
      retry?.addEventListener('click', start);
    });

    root.querySelectorAll('[data-mb-gallery-link]').forEach((link) => {
      if (link.dataset.mbBound || typeof HTMLDialogElement === 'undefined') return;
      link.dataset.mbBound = 'true';
      link.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const dialog = document.createElement('dialog');
        dialog.className = 'mb-lightbox';
        dialog.setAttribute('aria-label', link.dataset.galleryLabel || 'Partner facility photograph');
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'mb-button mb-lightbox__close';
        close.textContent = link.dataset.galleryClose || 'Close image';
        const image = document.createElement('img');
        image.src = link.href;
        image.alt = link.querySelector('img')?.alt || '';
        const caption = document.createElement('p');
        caption.textContent = link.dataset.caption || image.alt;
        dialog.append(close, image, caption);
        document.body.append(dialog);
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => { dialog.remove(); link.focus({ preventScroll: true }); }, { once: true });
        dialog.showModal();
        close.focus();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
